(function() { module.exports = window["Next"]["Icon"]; }());